import React from 'react';
import style from './TipsView.module.less';

const TipsView = (props)=>{
    const {textMap} = props;
    return (
        <div className={style.dec} style={{width:textMap.width}}>
            <div>{textMap.dec}</div>
            {textMap.img? <img src={textMap.img} className={style.img} style={{height:textMap.imgHeight}} />:null}
        </div>

    );
};


export default TipsView;



// WEBPACK FOOTER //
// ./src/components/TipsView/index.js